/* ============================================================
   Clay Paw Print Kit — front-end interactions (no dependencies)
   Operates on Liquid-rendered DOM via data-* attributes.
   ============================================================ */
(function () {
  'use strict';
  if (window.__cpkInit) return;
  window.__cpkInit = true;

  var onReady = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.cpk [data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cpk-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cpk-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    document.querySelectorAll('[data-cpk-gallery]').forEach(function (gallery) {
      var mainImg = gallery.querySelector('[data-cpk-main-img]');
      var mainLabel = gallery.querySelector('[data-cpk-main-label]');
      var thumbs = gallery.querySelectorAll('[data-cpk-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('cpk-thumb-active'); });
          thumb.classList.add('cpk-thumb-active');
          var src = thumb.getAttribute('data-src');
          var label = thumb.getAttribute('data-label') || '';
          if (mainImg && src) { mainImg.src = src; mainImg.alt = label; mainImg.style.display = 'block'; }
          if (mainLabel) mainLabel.textContent = label;
        });
      });
    });
  }

  /* ---------- Bundles + per-kit frame selectors ---------- */
  var CART = { qty: 1, colors: ['Wood'] };

  function currentColorsForQty(qty, prevColors) {
    var out = [];
    for (var i = 0; i < qty; i++) out.push(prevColors[i] || 'Wood');
    return out;
  }

  function refreshStickyPrice(root) {
    // update any element mirroring the selected bundle price/compare
    var active = root.querySelector('[data-cpk-bundle].cpk-bundle-active');
    if (!active) return;
    var price = active.getAttribute('data-price') || '';
    var compare = active.getAttribute('data-compare') || '';
    document.querySelectorAll('[data-cpk-sticky-price]').forEach(function (el) { el.textContent = price; });
    document.querySelectorAll('[data-cpk-sticky-compare]').forEach(function (el) { el.textContent = compare; });
  }

  function buildKitSelectors(bundle) {
    var host = bundle.querySelector('[data-cpk-kit-host]');
    if (!host) return;
    var qty = parseInt(bundle.getAttribute('data-qty'), 10) || 1;
    var options = (bundle.getAttribute('data-frame-values') || 'Wood,Black,White').split(',');
    host.innerHTML = '';
    for (var i = 0; i < qty; i++) {
      var row = document.createElement('div');
      row.className = 'cpk-kit-row';
      var num = document.createElement('span');
      num.className = 'cpk-kit-num';
      num.textContent = '#' + (i + 1);
      var sel = document.createElement('select');
      sel.className = 'cpk-kit-select';
      sel.setAttribute('data-cpk-kit-select', String(i));
      sel.setAttribute('aria-label', 'Frame colour for kit ' + (i + 1));
      options.forEach(function (opt) {
        var o = document.createElement('option');
        o.value = opt.trim(); o.textContent = opt.trim();
        if ((CART.colors[i] || 'Wood') === opt.trim()) o.selected = true;
        sel.appendChild(o);
      });
      (function (idx) {
        sel.addEventListener('click', function (e) { e.stopPropagation(); });
        sel.addEventListener('change', function (e) {
          e.stopPropagation();
          CART.colors[idx] = e.target.value;
        });
      })(i);
      row.appendChild(num); row.appendChild(sel);
      host.appendChild(row);
    }
  }

  function selectBundle(root, bundle) {
    root.querySelectorAll('[data-cpk-bundle]').forEach(function (b) {
      b.classList.remove('cpk-bundle-active');
      var host = b.querySelector('[data-cpk-kit-host]');
      if (host) host.innerHTML = '';
    });
    bundle.classList.add('cpk-bundle-active');
    CART.qty = parseInt(bundle.getAttribute('data-qty'), 10) || 1;
    CART.colors = currentColorsForQty(CART.qty, CART.colors);
    buildKitSelectors(bundle);
    refreshStickyPrice(root);
  }

  function initBundles() {
    document.querySelectorAll('[data-cpk-bundles]').forEach(function (root) {
      var bundles = root.querySelectorAll('[data-cpk-bundle]');
      bundles.forEach(function (bundle) {
        bundle.addEventListener('click', function () { selectBundle(root, bundle); });
        bundle.setAttribute('tabindex', '0');
        bundle.setAttribute('role', 'button');
        bundle.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectBundle(root, bundle); }
        });
      });
      var preselect = root.querySelector('[data-cpk-bundle][data-preselected="true"]') || bundles[0];
      if (preselect) selectBundle(root, preselect);
    });
  }

  /* ---------- Add to cart (real Shopify cart) ---------- */
  function frameVariantMap() {
    var el = document.querySelector('[data-cpk-variant-map]');
    if (!el) return null;
    try { return JSON.parse(el.getAttribute('data-cpk-variant-map')); } catch (e) { return null; }
  }

  function aggregateItems() {
    var map = frameVariantMap();
    if (!map) return null;
    var counts = {};
    for (var i = 0; i < CART.qty; i++) {
      var color = CART.colors[i] || 'Wood';
      var vid = map[color] || map[Object.keys(map)[0]];
      counts[vid] = (counts[vid] || 0) + 1;
    }
    return Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
  }

  function flashAdded(btn) {
    if (!btn) return;
    var label = btn.querySelector('[data-cpk-atc-label]') || btn;
    var original = btn.getAttribute('data-label-default') || label.textContent;
    label.textContent = btn.getAttribute('data-label-added') || 'Added ✓';
    btn.classList.add('cpk-atc-added');
    clearTimeout(btn.__t);
    btn.__t = setTimeout(function () { label.textContent = original; btn.classList.remove('cpk-atc-added'); }, 1600);
  }

  function openCart() {
    // Prefer theme cart drawer if present, else go to /cart
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .drawer--cart');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    var trigger = document.querySelector('[aria-controls="CartDrawer"], a[href$="/cart"]');
    if (drawer) { document.dispatchEvent(new CustomEvent('cart:open')); return; }
    if (trigger && trigger.click) { /* let theme handle */ }
    else window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
  }

  function addToCart(btn) {
    var items = aggregateItems() || [];
    document.querySelectorAll('input[data-cpk-addon]:checked').forEach(function (el) {
      var vid = parseInt(el.getAttribute('data-variant-id'), 10);
      if (vid) items.push({ id: vid, quantity: 1 });
    });
    if (!items.length) { flashAdded(btn); return; }
    var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () {
        flashAdded(btn);
        document.dispatchEvent(new CustomEvent('cpk:added'));
        // Nudge theme cart to refresh if it listens
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () { flashAdded(btn); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  function initAtc() {
    document.querySelectorAll('[data-cpk-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); addToCart(btn); });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-cpk-countdown]').forEach(function (el) {
      var mins = parseInt(el.getAttribute('data-minutes'), 10);
      var secs = parseInt(el.getAttribute('data-seconds'), 10);
      var total = (isNaN(mins) ? 45 : mins) * 60 + (isNaN(secs) ? 56 : secs);
      var tick = function () {
        total = total <= 0 ? (59 * 60 + 59) : total - 1;
        var m = String(Math.floor(total / 60)).padStart(2, '0');
        var s = String(total % 60).padStart(2, '0');
        el.textContent = m + ':' + s;
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Accordions (hero + FAQ) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-cpk-accordion]').forEach(function (group) {
      var items = group.querySelectorAll('[data-cpk-acc-item]');
      items.forEach(function (item) {
        var head = item.querySelector('[data-cpk-acc-head]');
        var panel = item.querySelector('[data-cpk-acc-panel]');
        if (!head) return;
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');
        var toggle = function () {
          var open = item.classList.toggle('cpk-acc-open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        };
        head.addEventListener('click', toggle);
        head.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
        if (panel) panel.hidden = !item.classList.contains('cpk-acc-open');
        head.setAttribute('aria-expanded', item.classList.contains('cpk-acc-open') ? 'true' : 'false');
      });
    });
  }

  /* ---------- Review carousel ---------- */
  function initCarousel() {
    document.querySelectorAll('[data-cpk-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-cpk-carousel-track]');
      var prev = root.querySelector('[data-cpk-carousel-prev]');
      var next = root.querySelector('[data-cpk-carousel-next]');
      if (!track) return;
      var index = 0;
      var step = function () {
        var card = track.querySelector('.cpk-review-card');
        if (!card) return 384;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '24') || 24;
        return card.getBoundingClientRect().width + gap;
      };
      var maxIndex = function () {
        var total = track.querySelectorAll('.cpk-review-card').length;
        var visible = Math.max(1, Math.floor(root.getBoundingClientRect().width / step()));
        return Math.max(0, total - visible);
      };
      var apply = function () { track.style.transform = 'translateX(-' + (index * step()) + 'px)'; };
      if (next) next.addEventListener('click', function () { index = Math.min(index + 1, maxIndex()); apply(); });
      if (prev) prev.addEventListener('click', function () { index = Math.max(index - 1, 0); apply(); });
      window.addEventListener('resize', function () { index = Math.min(index, maxIndex()); apply(); });
    });
  }

  /* ---------- Sticky ATC bar (show on scroll past hero) ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-cpk-sticky-bar]');
    if (!bar) return;
    var anchor = document.querySelector('[data-cpk-atc]');
    var show = function () {
      var y = window.scrollY || window.pageYOffset;
      var trigger = anchor ? anchor.getBoundingClientRect().bottom + y : 600;
      if (y > trigger) bar.classList.add('cpk-sticky-visible');
      else bar.classList.remove('cpk-sticky-visible');
    };
    show();
    window.addEventListener('scroll', show, { passive: true });
  }

  /* ---------- Recently-purchased toast ---------- */
  function initToast() {
    var toast = document.querySelector('[data-cpk-toast]');
    if (!toast) return;
    var names = (toast.getAttribute('data-names') || 'Emma,James,Sophie,Olivia,Daniel,Grace,Liam,Chloe').split(',');
    var cities = (toast.getAttribute('data-cities') || 'London,Austin,Manchester,Toronto,Dublin,Seattle,Bristol,Denver').split(',');
    var nameEl = toast.querySelector('[data-cpk-toast-name]');
    var cityEl = toast.querySelector('[data-cpk-toast-city]');
    var idx = 0, visible = false;
    var interval = parseInt(toast.getAttribute('data-interval'), 10) || 5500;
    setInterval(function () {
      visible = !visible;
      if (visible) {
        if (nameEl) nameEl.textContent = (names[idx % names.length] || '').trim();
        if (cityEl) cityEl.textContent = (cities[idx % cities.length] || '').trim();
        toast.style.display = 'flex';
        toast.style.animation = 'cpk-toastIn .4s ease';
      } else {
        toast.style.display = 'none';
        idx++;
      }
    }, interval);
  }

  onReady(function () {
    initReveal();
    initGallery();
    initBundles();
    initAtc();
    initCountdown();
    initAccordions();
    initCarousel();
    initStickyBar();
    initToast();
  });
})();
